import { useState , useEffect } from 'react';
import FontsTable from '../components/Dashboard/FontsTable';
import Search from '../components/Dashboard/Search.js';
import './../styles/Dashboard.css';
import FontEditorModal from '../components/Dashboard/FontEditorModal.js';
import config from '../constants/config.js';
import useLoadFonts from '../hooks/useLoadFonts.js';

function Fonts() {
    const [ showModal, setShowModal ] = useState( false );
    const [ fontToEdit, setFontToEdit ] = useState( null );
    const [ fonts , setFonts ] = useState( [] );
    const [ loadingTable , setLoadingTable ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ totalPages, setTotalPages ] = useState( 1 );
    const [ reloadTable , setReloadTable ] = useState( 0 );

    useLoadFonts( fonts );

    function openModal( font = null ) {
        setFontToEdit( font );
        setShowModal( true );
    }

    useEffect( () => {
        async function load() {
            setLoadingTable( true );

            /**
             * Load Fonts. 
             */
            const _fonts = await getFonts( currentPage );
            if ( _fonts != null ) {
                setTotalPages( _fonts?.pagination?.total_pages || 0 );
                setFonts( _fonts?.fonts || [] );
            }

            setLoadingTable( false );
        }

        load();
    } , [ currentPage , reloadTable ] );

    async function getFonts( page ) {
        let fontData = null;

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/fonts?page=${encodeURIComponent( page )}&limit=${encodeURIComponent(25)}`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            
            const response = await fetch( url , requestSettings );
            const data = await response.json();

            if ( data?.fonts?.length > 0 ) {
                fontData = data;
            }
        } catch ( error ) {
            console.log( error );
        }

        return fontData;
    }

    return(
        <div className="dashboard-wrapper">
            <div className="dashboard-header">
                <div className="actions-row">
                    <div className="actions-group">
                        <button className="action-btn" onClick={() => openModal()}>
                            <span className="icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 0.53125C7.5 0.239062 7.25893 0 6.96429 0C6.66964 0 6.42857 0.239062 6.42857 0.53125V6.375H0.535714C0.241071 6.375 0 6.61406 0 6.90625C0 7.19844 0.241071 7.4375 0.535714 7.4375H6.42857V13.2812C6.42857 13.5734 6.66964 13.8125 6.96429 13.8125C7.25893 13.8125 7.5 13.5734 7.5 13.2812V7.4375H13.3929C13.6875 7.4375 13.9286 7.19844 13.9286 6.90625C13.9286 6.61406 13.6875 6.375 13.3929 6.375H7.5V0.53125Z" fill="white"/>
                                </svg>
                            </span>
                            <span className="title">Add New Font</span>
                        </button>
                    </div>
                    <div className="actions-group">
                        <Search />
                    </div>
                </div>
            </div>
            <div className="dashboard-body">
                <h1 className="dashboard-title">Fonts</h1>
                <FontsTable 
                    fonts={ fonts } 
                    loading={ loadingTable } 
                    pagination={{
                        currentPage: currentPage,
                        totalPages: totalPages
                    }}
                    goToPreviousPage={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    goToNextPage={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    onUpdate={() => setReloadTable( reloadTable + 1 ) }
                />
            </div>

            {showModal && (
                <FontEditorModal
                    isOpen={showModal}
                    onClose={() => { 
                        setShowModal(false)
                    }}
                    onAdd={() => {
                        setReloadTable( reloadTable + 1 );
                    }}
                    initialData={fontToEdit}
                />
            )}
        </div>
    );
}

export default Fonts;